import { createRoute, redirect } from '@tanstack/react-router';

import { menuLayoutRoute } from 'root/MenuLayout';

const invoicesLegacyMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'invoices',
});

const invoicesLegacyIndexRoute = createRoute({
  getParentRoute: () => invoicesLegacyMainRoute,
  path: '/',
  beforeLoad: ({ search }) => redirect({ to: '/finance/invoices', search }),
});

const invoicesLegacySettingsRoute = createRoute({
  getParentRoute: () => invoicesLegacyMainRoute,
  path: 'settings',
  beforeLoad: () => redirect({ to: '/finance/invoices/settings' }),
});

const invoicesLegacyDetailRoute = createRoute({
  getParentRoute: () => invoicesLegacyMainRoute,
  path: '$invoiceId',
  beforeLoad: ({ params, search }) =>
    redirect({
      to: '/finance/invoices/$invoiceId',
      params: { invoiceId: params.invoiceId },
      search,
    }),
});

export const invoicesLegacyRedirectRouteTree = invoicesLegacyMainRoute.addChildren({
  invoicesLegacyIndexRoute,
  invoicesLegacySettingsRoute,
  invoicesLegacyDetailRoute,
});
